import { useState } from 'react'
import ListadoProgramados from './ListadoProgramados'
import ImportarProgramadosExcel from './importarProgramadosExcel/Index'
import NuevoProgramado from './nuevoProgramado/Index'
import EditarProgramado from './editarProgramado/Index'
import { FacturaAPI } from '../../../../../../../api/facturas.api'
import ResizableModal from '../../../../../ui/ResizableModal'
import LucaModalProgramados from './components/LucaModalProgramados'

export default function FacturasProgramadas() {
  const [activeModal, setActiveModal] = useState(null) // 'excel' | 'new_single' | 'edit_single' | null
  const [selectedDoc, setSelectedDoc] = useState(null)
  const [loading, setLoading] = useState(false)
  const [refreshTrigger, setRefreshTrigger] = useState(0)
  const [modalFooter, setModalFooter] = useState(null)

  const refreshList = () => setRefreshTrigger(prev => prev + 1)

  const handleGoExcel = () => setActiveModal('excel')
  const handleNewSingle = () => setActiveModal('new_single')
  const handleCloseModal = ({ refresh = false } = {}) => {
    setActiveModal(null)
    setSelectedDoc(null)
    setModalFooter(null)
    if (refresh) refreshList()
  }

  const handleEdit = async doc => {
    if (!doc?.id || !doc?.sender) {
      console.warn('Missing doc id or sender for fetching full details', doc)
      setSelectedDoc(doc)
      setActiveModal('edit_single')
      return
    }

    setLoading(true)
    try {
      const api = new FacturaAPI()
      const { data } = await api.getDocumentoProgramado(doc.id, doc.sender)
      setSelectedDoc(data || doc)
      setActiveModal('edit_single')
    } catch (error) {
      console.error('Error fetching full document details:', error)
      setSelectedDoc(doc) // Fallback to basic row data if API fails
      setActiveModal('edit_single')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='space-y-6'>
      {loading && (
        <div className='flex flex-col items-center justify-center rounded-2xl border border-slate-200 bg-white p-12 shadow-sm animate-pulse'>
          <div className='animate-spin h-10 w-10 border-4 border-primary border-t-transparent rounded-full mb-4'></div>
          <p className='text-gray-500 font-medium'>Obteniendo detalles del documento...</p>
        </div>
      )}

      {!loading && (
        <ListadoProgramados
          onExcel={handleGoExcel}
          onNewSingle={handleNewSingle}
          onEdit={handleEdit}
          refreshTrigger={refreshTrigger}
        />
      )}

      <ResizableModal
        open={activeModal === 'new_single'}
        onClose={() => handleCloseModal()}
        width={1000}
        height={820}
        minWidth={960}
        minHeight={640}
        size='medium'
      >
        <div className='h-full overflow-hidden rounded-2xl bg-white'>
          <div className='border-b border-slate-200 px-5 py-4'>
            <p className='text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-500'>
              Facturación programada
            </p>
            <h3 className='mt-1 text-xl font-bold text-slate-950'>Nueva programación</h3>
            <p className='mt-1 text-sm text-slate-600'>
              Configura una factura recurrente para emisión automática.
            </p>
          </div>

          <div className='h-[calc(100%-96px)] overflow-y-auto bg-slate-50 p-5'>
            <NuevoProgramado
              onBack={() => handleCloseModal({ refresh: true })}
              isModal
            />
          </div>
        </div>
      </ResizableModal>

      <ResizableModal
        open={activeModal === 'edit_single'}
        onClose={() => handleCloseModal()}
        width={1000}
        height={820}
        minWidth={960}
        minHeight={640}
        size='medium'
      >
        <div className='h-full overflow-hidden rounded-2xl bg-white'>
          <div className='border-b border-slate-200 px-5 py-4'>
            <p className='text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-500'>
              Facturación programada
            </p>
            <h3 className='mt-1 text-xl font-bold text-slate-950'>Editar programación</h3>
            <p className='mt-1 text-sm text-slate-600'>
              Actualiza la configuración y los datos del documento programado.
            </p>
          </div>

          <div className='h-[calc(100%-96px)] overflow-y-auto bg-slate-50 p-5'>
            {selectedDoc && (
              <EditarProgramado
                doc={selectedDoc}
                onBack={() => handleCloseModal({ refresh: true })}
                isModal
              />
            )}
          </div>
        </div>
      </ResizableModal>

      <LucaModalProgramados
        open={activeModal === 'excel'}
        onClose={() => handleCloseModal()}
        maxWidth='max-w-6xl'
        footer={modalFooter}
      >
        <ImportarProgramadosExcel
          onBack={() => handleCloseModal({ refresh: true })}
          isModal
          setModalFooter={setModalFooter}
        />
      </LucaModalProgramados>
    </div>
  )
}
